export const QUESTION_LIBRARY_ENDPOINTS = {
  LIST: "/survey-manager/question-library/list",
  CREATE: "/survey-manager/question-library/create",
  UPDATE: (id) => `/survey-manager/question-library/${id}`,
  DELETE: (id) => `/survey-manager/question-library/${id}`,
  TOGGLE_FAVOURITE: (id) => `/survey-manager/question-library/${id}/favourite`,
  TOGGLE_ARCHIVE: (id) => `/survey-manager/question-library/${id}/archive`,
};
